"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ColorHash = void 0;
exports.hash = hash;
const tslib_1 = require("tslib");
const color_hash_1 = tslib_1.__importDefault(require("color-hash"));
const CH = new color_hash_1.default({ hash: 'bkdr', saturation: [0.65, 0.35, 0.5], lightness: [0.65, 0.35, 0.5] });
const COLOR_HASHES = {};
function hash(id) {
    var color = COLOR_HASHES[id];
    if (color == null) {
        color = COLOR_HASHES[id] = CH.hex(id);
    }
    return color;
}
exports.ColorHash = { hash };
//# sourceMappingURL=color.hash.js.map